const steps = [
  {
    key: 'ONE_BEACON',
    viewport: {
      longitude: -73.98,
      latitude: 40.741,
      zoom: 12,
      bearing: 0,
      pitch: 0
    },
    h: 'How Location Verification works:\nZone Anchors.',
    h2:
      'This ties in the geospatial layer with the vertical stack of smart contracts deployed on the vertical crypto-ledger.',
    p:
      'FOAM incentivizes the creation of a distributed network of radio beacons, called Zone Anchors. After joining the network, Zone Anchors send signals to discover and connect with others nearby.',
    img: { src: '/publicAssets/mapStory/Beacons.svg', alt: '' }
    // icon: { src: '/publicAssets/mapStory/mapstep1.png', alt: '' }
  },
  {
    key: 'MANY_BEACONS',
    viewport: {
      longitude: -73.994894,
      latitude: 40.730608,
      zoom: 14,
      bearing: 15,
      pitch: 0
    },
    h: 'Clock Synchronization.',
    h2:
      'This ties in the geospatial layer with the vertical stack of smart contracts deployed on the vertical crypto-ledger.',
    p:
      'Location verification depends on accurate and synchronized clocks. Using a Byzantine Fault Tolerant clock synchronization protocol, Zone Anchors send messages until a consensus can be reached on the time. The timed difference of messages sent and received allows for location to be calculated and the geometry of the network to be determined.',
    img: { src: '/publicAssets/mapStory/Clocks.svg', alt: '' }
    // icon: { src: '/publicAssets/mapStory/mapstep2.png', alt: '' }
  },
  {
    key: 'TRIANGULATIOM',
    viewport: {
      longitude: -73.99734,
      latitude: 40.730828,
      zoom: 15,
      bearing: 20,
      pitch: 0
    },
    h: 'Zone Formation.',
    h2:
      'This ties in the geospatial layer with the vertical stack of smart contracts deployed on the vertical crypto-ledger.',
    p:
      'Once synchronized, groups of Zone Anchors can establish a Zone. They pledge to offer location services that are enforced by smart contract safety deposits, which provide accountability for faulty behavior. A Zone maintains a quorum on time and space.',
    img: { src: '/publicAssets/mapStory/Zones.svg', alt: '' }
    // icon: { src: '/publicAssets/mapStory/mapstep3.png', alt: '' }
  },
  {
    key: 'FOAMY',
    viewport: {
      longitude: -73.997341,
      latitude: 40.729,
      zoom: 16,
      bearing: 25,
      pitch: 40
    },
    h: 'Triangulation.',
    h2:
      'This ties in the geospatial layer with the vertical stack of smart contracts deployed on the vertical crypto-ledger.',
    p:
      'Zones can include time-stamped messages from customers in a competitive market for a transaction fee. This is done while Zones are resynchronizing clocks and publishing their time logs to a data store. Validators provide fraud proofs and calculate triangulations for precise location data to verify final Presence Claims.',
    img: { src: '/publicAssets/mapStory/Triangulation.svg', alt: '' }
    // icon: { src: '/publicAssets/mapStory/mapstep4.png', alt: '' }
  }
]

export { steps }



// WEBPACK FOOTER //
// ./src/content/steps.js